import { Grid } from "@mui/material";
import MxFormL3RushCounterField from "@rf-l3/form/MxFormL3Counter";
import { CModalSchemaKeys } from "./BuildingUnitFormModal";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const FeatureEnvironment = () => {
  return (
    <Grid container rowGap={1.5}>
      <Grid item xs={12} mb={0.5}>
        <MxFormSubTitle label="Selecciona la cantidad" />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.bedrooms}
          label="Habitaciones"
          countRender={7}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.bathrooms}
          label="Baños"
          countRender={7}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.halfBathrooms}
          label="Medio baños"
          countRender={7}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.parkingSpots}
          label="Parqueo"
          countRender={7}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.levelFloor}
          label="Nivel de piso"
          countRender={7}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3RushCounterField
          withreacthookform={1}
          name={CModalSchemaKeys.totalFloor}
          label="Total de pisos"
          countRender={7}
        />
      </Grid>
    </Grid>
  );
};

export default FeatureEnvironment;
